import { Component, OnInit } from '@angular/core';
import { Student, Staff } from '../Models/index';
import { Router }            from '@angular/router';
import { StudentService } from '../Service/student.service';
import { StaffService } from '../Service/staff.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  pinnum: number;
  errorMsg : string = "";
  checkStaff: Staff;
  checkStudent: Student;
  schoolName = '';

  constructor(
    private staffService: StaffService,
    private studentService: StudentService,
    private router: Router,
  ) { }

  ngOnInit() {
    // According login information get school name from localStorage
    this.schoolName = localStorage.getItem('name');
  }


  // Get staff information by pin number
  getStaffbyPin(pinnum: any) {
    // Call api
    this.staffService.getStaffbyPin(pinnum)
      .subscribe(data => {
        if(data[0][0]){    //[0][0] becasue json data formate is object.object.object
          this.checkStaff = data[0][0];
          this.goToCheckStuff(this.checkStaff);
        }else {
          this.errorMsg = "This Pin # not in this school";
        }

      });
  }
  // Get student information by pin number
  getStudentbyPin(pinnum: any) {
    // Call api
    this.studentService.getStudentbyPin(pinnum)
      .subscribe(data => {
        // Data from backend is not null, then get this student who has the pin number just type
        if(data[0][0]){   //[0][0] becasue json data formate is object.object.object
          this.checkStudent = data[0][0];
          this.goToCheckStudent(this.checkStudent);
        }
        // Data from backend is null, which means there is no student has the pin number just type
        else {
          this.errorMsg = "This Pin # not in this school";
        }

      });
  }

  // Input check, to see if the input number or string is valid
  check(){

    let authenticatedpinnum: boolean = false;
    let authenticatedpinnum2: boolean = false;
    // Using regular expression to check, student should be four digits, staff should be three characters.
    const Stuffre = /^[a-z]{3}$/;
    const Studentre = /^[0-9]{4}$/;

    // Input is null
    if(this.pinnum == undefined){
      this.errorMsg = "Plase Type a Pin #!";
    }else{
      // Input is three characters
      if(Stuffre.test(this.pinnum.toString())){
        // Get stuff information by pin #.
        this.getStaffbyPin(this.pinnum);
      }
      // Input is four digits
      else if(Studentre.test(this.pinnum.toString())){
        // Get student information by pin #.
        this.getStudentbyPin(this.pinnum);
      }
      // Input is not valid
      else{
        this.errorMsg = "Wrong Pin #! Type Again!";
      }
    }



  }
  // Route to student check in/out page
  goToCheckStudent(student: Student): void {
    this.router.navigate(['/attendance/student', student.pinnum]);
  }
  // Route to staff check in/out page
  goToCheckStuff(staff: Staff): void {
    this.router.navigate(['/attendance/staff', staff.pinnum]);
  }

}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/home/home.component.ts